import csvValue from "./csvValue.js";


function persistentIdToCsv(data){
    let res = "Marts_id,Entity,Uniprot_ID,Genbank_ID,SMILES,Mechanism_ID\n"
    data.forEach((element) => {
        let new_line = `"${csvValue(element.persistent_id)}","${csvValue(element.source_table)}","${csvValue(element.Uniprot_ID)}","${csvValue(element.Genbank_ID)}","${csvValue(element.SMILES)}","${csvValue(element.mechanism_ID)}"\n`
        res = res + new_line
    }); 
    return res
    } 

function historicNoteToCSV(data){
    let res = "Marts_id,Note,Date\n"
    data.forEach((element) => {
        let new_line = `"${csvValue(element.persistent_id)}","${csvValue(element.note)}","${csvValue(element.note_date)}"\n`
        res = res + new_line
    });
    return res
}
    
    export  { persistentIdToCsv, historicNoteToCSV }